import React from 'react';
import styled from 'styled-components';

import { useModal } from '@tager/web-components';

import DetailedCarFixedPreviewPanel from '@/components/DetailedCarFixedPreviewPanel';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import DetailedCarModal from '@/components/modals/DetailedCarModal';
import {
  getDealersOptions,
  getEventParams,
} from '@/modules/DetailedCar/DetailedCar.helper';
import { StyledOverlay } from '@/components/modals/shared/StyledOverlay';
import useSettingItem from '@/hooks/useSettingItem';
import defaultStockCar from '@/assets/images/cars-stock/defaultStockCar.png';
import { getCarsStockPriceText } from '@/utils/common';
import { usePhoneNumber } from '@/hooks/usePhoneNumber';
import { getTheme } from '@/constants/theme';

function FixedPreviewPanel() {
  const data = useTypedSelector(selectDetailedCarData);
  const openModal = useModal();

  const isOnlineTestDrive = useSettingItem('DETAILED_CAR_ONLINE_TEST_DRIVE');

  const phone = usePhoneNumber();

  if (!data) {
    return null;
  }

  const {
    id,
    pricing,
    testDrive,
    actionsDisabled,
    media: { images },
    catalog: { brand, model },
    params: { body },
  } = data;

  function handleDetailedCarModal(
    type: 'APPLICATION' | 'TEST_DRIVE' | 'TEST_DRIVE_OFFLINE'
  ) {
    if (!data) {
      return;
    }

    openModal(
      DetailedCarModal,
      {
        type,
        typeState: 'new',
        car: {
          id,
          name: `${brand.name} ${model?.name ?? ''}`,
          price: pricing?.discountPrice ?? pricing?.price ?? undefined,
          bodyType: body?.label ?? '',
          image: { url: images.length ? images[0] : defaultStockCar },
          dealers: getDealersOptions(data),
          googleEventParams: getEventParams(data),
          hideCreditAndTradeIn: getTheme() === 'b2b',
        },
      },
      { scrollLockDisabled: true, components: { Overlay: StyledOverlay } }
    );
  }

  const price = !pricing?.price
    ? {
        text: getCarsStockPriceText(phone, false),
      }
    : {
        amount: pricing?.tradeInPrice
          ? pricing.tradeInPrice
          : pricing?.discountPrice
          ? pricing.discountPrice
          : pricing?.price,
        discount: pricing?.discountPrice
          ? pricing.price - pricing.discountPrice
          : undefined,
        tradeIn: pricing?.tradeInPrice
          ? pricing.price - pricing.tradeInPrice
          : undefined,
      };

  return (
    <Component>
      <DetailedCarFixedPreviewPanel
        title={`${brand.name} ${model?.name ?? ''}`}
        buttonTitle={
          !actionsDisabled
            ? testDrive.available
              ? 'ТЕСТ-ДРАЙВ'
              : 'ПОЛУЧИТЬ ПРЕДЛОЖЕНИЕ'
            : undefined
        }
        price={price}
        onClick={() =>
          handleDetailedCarModal(
            testDrive.available
              ? isOnlineTestDrive
                ? 'TEST_DRIVE'
                : 'TEST_DRIVE_OFFLINE'
              : 'APPLICATION'
          )
        }
      />
    </Component>
  );
}

export default FixedPreviewPanel;

const Component = styled.div``;
